import { useLazyApiGatewayQuery } from '~hooks';
import { CONTROL_PRODUCT_CODE } from '~queries';
import { Query, QueryControlCodeArgs } from '~types/appsync.types';

const useProductCodeControl = () => {
  const [executeProductCodeControl, state] = useLazyApiGatewayQuery<Query, QueryControlCodeArgs>(
    CONTROL_PRODUCT_CODE,
  );

  return [executeProductCodeControl, state] as const;
};

export default useProductCodeControl;
